<script setup lang="ts">
const { t } = useI18n()
</script>

<template>
  <AppTooltip width="w-[360px]" tooltip-position="bottom">
    <BaseIcon name="IconoirInfoCircle" class="h-4 w-4 cursor-pointer text-foreground-secondary" />
    <template #tooltip-content>
      <div class="flex flex-col gap-2 text-left">
        <p>
          <i18n-t keypath="pages.autopilot.autopilotsPage.data.revenueTooltip" tag="p">
            <template #bold>
              <span class="font-bold">{{ t('pages.autopilot.autopilotsPage.data.revenueTooltipBold') }}</span>
            </template>
          </i18n-t>
        </p>
        <p>
          <i18n-t keypath="pages.autopilot.autopilotsPage.data.revenueTooltip2" tag="p">
            <template #bold>
              <span class="font-bold">{{ t('pages.autopilot.autopilotsPage.data.revenueTooltipBold2') }}</span>
            </template>
          </i18n-t>
        </p>
      </div>
    </template>
  </AppTooltip>
</template>
